__turbopack_context__.v({
  "course-heading": "course-includes-module-scss-module__YOJ8Yq__course-heading",
  "course-includes-body": "course-includes-module-scss-module__YOJ8Yq__course-includes-body",
  "course-includes-sidebar": "course-includes-module-scss-module__YOJ8Yq__course-includes-sidebar",
  "course-includes-wrapper-sidebar": "course-includes-module-scss-module__YOJ8Yq__course-includes-wrapper-sidebar",
  "double-list-container": "course-includes-module-scss-module__YOJ8Yq__double-list-container",
  "incentives-list": "course-includes-module-scss-module__YOJ8Yq__incentives-list",
});
